import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import LoadingAdapter from "libs/utils/LoadingAdapter";
import EmployeeService from "services/EmployeeService";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

let initialState = { list: [], detail: null };

export const getEmployeeList = createAsyncThunk(
  "employee/getEmployeeList",
  async (body) => {
    const response = await EmployeeService.list(body);
    return response?.results;
  }
);

export const getEmployeeDetail = createAsyncThunk(
  "employee/getEmployeeDetail",
  async (empId) => {
    const response = await EmployeeService.list({ empId });
    if (response.status && response?.results?.length > 0) {
      return response?.results[0];
    }
  }
);

export const updateEmployee = createAsyncThunk(
  "employee/updateEmployee",
  async (body) => {
    const response = await EmployeeService.updateEmp(body);
    if (response.status) {
      const response2 = await EmployeeService.list({ empId: body.empId });
      if (response2.status && response2?.results?.length > 0) {
        return response2?.results[0];
      }
    }
  }
);

export function Addemployee(data) {
  return async (dispatch) => {
    // console.log(data);
    // dispatch(loginRequest());

    try {
      const response = await EmployeeService.AddEmp(data);
      const results = response?.results || {};

      // HttpClient.setToken(results.accessToken);
      const MySwal = withReactContent(Swal);

      MySwal.fire({
        icon: "success",
        didOpen: () => {
          MySwal.clickConfirm();
        },
      }).then(() => {
        return MySwal.fire("Success!", "เพิ่มพนักงานสำเร็จ !", "success").then(
          (result) => {
            if (result.isConfirmed) {
              // console.log(respose.data.id);
            }
          }
        );
      });

      // Router.replace("/");
    } catch (error) {
      alert("Opps!!! " + error.message);
      throw error;
    }
  };
}

const employeeSlice = createSlice({
  name: "employee",
  initialState: LoadingAdapter.getInitialState(initialState),
  reducers: {
    clearAll: LoadingAdapter.getInitialState(initialState),
    clearAsyncState: LoadingAdapter.clearAsyncState,
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(getEmployeeList, builder, ["list"]);
    LoadingAdapter.applyAsyncBuilder(getEmployeeDetail, builder, ["detail"]);
    LoadingAdapter.applyAsyncBuilder(updateEmployee, builder, ["detail"]);
  },
});

export default employeeSlice.reducer;
